import React from "react";
import { categoryListService } from "../../../application/service/help/category-list";
import {
  Category,
  HelpContent,
  Product,
  Tag,
} from "../../../application/domain/help/help-entity";
import { productListService } from "../../../application/service/help/product-list";
import { productService } from "../../../application/service/help/product";
import { tagListService } from "../../../application/service/help/tag-list";
import { contentService } from "../../../application/service/help/content";
import { contentListService } from "../../../application/service/help/content-list";

export const useCategoryList = (productId?: string) => {
  const [categoryList, setCategoryList] = React.useState<Category[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const getCategoryList = async () => {
      setIsLoading(true);
      const result = await categoryListService.fetchCategoryList(productId);
      setCategoryList(result);
      setIsLoading(false);
    };
    getCategoryList();
  }, [productId]);
  return {
    categoryList,
    isLoading,
  };
};

export const useProductList = () => {
  const [productList, setProductList] = React.useState<Product[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const getProductList = async () => {
      setIsLoading(true);
      const result = await productListService.fetchProductList();
      setProductList(result);
      setIsLoading(false);
    };
    getProductList();
  }, []);

  return {
    productList,
    isLoading,
  };
};

export const useProduct = (productId?: string) => {
  const [product, setProduct] = React.useState<Product | null>(null);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    if (!productId) return;
    const getProduct = async () => {
      setIsLoading(true);
      const result = await productService.fetchProduct(productId);
      setProduct(result);
      setIsLoading(false);
    };
    getProduct();
  }, [productId]);

  return {
    product,
    isLoading,
  };
};

export const useTagList = () => {
  const [tagList, setTagList] = React.useState<Tag[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const getTagList = async () => {
      setIsLoading(true);
      const result = await tagListService.fetchTagList();
      setTagList(result);
      setIsLoading(false);
    };
    getTagList();
  }, []);

  return {
    tagList,
    isLoading,
  };
};

export const useContentList = ({
  query,
  productId,
  tagIds,
  limit,
}: {
  query?: string;
  productId?: string;
  tagIds?: string[];
  limit?: number;
}) => {
  const [contentList, setContentList] = React.useState<HelpContent[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const getContentList = async () => {
      setIsLoading(true);
      const result = await contentListService.fetchContentList(
        query,
        productId,
        tagIds,
        limit,
      );
      setContentList(result);
      setIsLoading(false);
    };
    getContentList();
  }, [query, productId, tagIds, limit]);

  return {
    contentList,
    isLoading,
  };
};

export const useContent = (objectSlug: string) => {
  const [content, setContent] = React.useState<HelpContent | null>(null);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    if (!objectSlug) return;
    const getContent = async () => {
      setIsLoading(true);
      const result = await contentService.fetchContent(objectSlug);
      setContent(result);
      setIsLoading(false);
    };
    getContent();
  }, [objectSlug]);

  return {
    content,
    isLoading,
  };
};
